export default __webpack_public_path__ + "static/media/itau_flag.387b9b70.svg";